import { emptySplitApi } from './index'

export const notesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotesByUser: builder.query({
      query: (model) => ({
        url: `api/v1/foundation-service/notes/by-user?`
          + `&pageNumber=${model?.pageNumber || 0}`
          + `&pageSize=${model?.pageSize || 10}`
          + `&orderField=${model?.orderField || 'title'}`
          + `&orderDirection=${model?.orderDirection || 'asc'}`
          + `&tableOrder=${model?.tableOrder || 'All'}`,
        method: "GET",
      }),
    }),
    getNoteList: builder.mutation({
      query: (model) => ({
        url: `api/v1/foundation-service/notes?`
          + `&profileId=${model?.profileId}`
          + `&flagStatusFilter=${model?.flagStatusFilter || 'All'}`
          + `&pageNumber=${model?.pageNumber || 0}`
          + `&pageSize=${model?.pageSize || ''}`
          + `&orderField=${model?.orderField || 'description'}`
          + `&orderDirection=${model?.orderDirection || 'asc'}`,
        method: "GET",
      }),
    }),
    getNoteCurrentList: builder.query({
      query: ({ profileId }) => ({
        url: `api/v1/foundation-service/notes/current-list/${profileId}`,
        method: "GET"
      }), 
      providesTags: (result) => [...result.map(({ profileId }) => ({ type: 'NoteList', id: profileId })), { type: 'NoteList', id: 'LIST' } ],
    }),
    insertNote: builder.mutation({
      query: (model) => ({
        url: `api/v1/foundation-service/notes`,
        method: "POST",
        body: model
      }),
      invalidatesTags: (result, error, { profileId }) => [{ type: 'NoteList', id: profileId }, { type: 'NoteList', id: 'LIST' }],
    }),
    updateNote: builder.mutation({
      query: (model) => ({
        url: `api/v1/foundation-service/notes/${model.id}`,
        method: "PATCH",
        body: model
      }),
      invalidatesTags: (result, error, { profileId }) => [{ type: 'NoteList', id: profileId }],
    }),
    deleteNote: builder.mutation({
      query: (id) => ({
        url: `api/v1/foundation-service/notes/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { profileId }) => [{ type: 'NoteList', id: profileId }],
    }),
    togglePinNote: builder.mutation({
      query: (id) => ({
        url: `api/v1/foundation-service/notes/${id}/toggle-pin`,
        method: "POST",
      })
    }),
    getNoteDocuments: builder.mutation({
      query: (id) => `api/v1/foundation-service/notes-documents/${id}`,
    }),
    uploadNoteDocuments: builder.mutation({
      query: (model) => ({
        url: `api/v1/foundation-service/notes-documents`,
        method: "POST",
        body: model,
      })
    }),
    deleteNoteDocument: builder.mutation({
      query: ({ id, documentId }) => ({
        url: `api/v1/foundation-service/notes-documents/${id}/document/${documentId}`,
        method: "DELETE",
      })
    }),
    getNoteAlerts: builder.query({
      query: (model) => ({
        url: `api/v1/foundation-service/notes/alerts?`
          + `&pageNumber=${model?.pageNumber || 0}`
          + `&pageSize=${model?.pageSize || 25}`
          + `&orderField=${model?.orderField || 'NotificationDate'}`
          + `&orderDirection=${model?.orderDirection || 'desc'}`
          + `&profileId=${model?.profileId || ''}`
          + `&flagStatusFilter=${model?.flagStatusFilter || 'All'}`,
        method: "GET",
      }),
    }),
    updateAlert: builder.mutation({
      query: ({ id, ...model }) => ({
        url: `api/v1/foundation-service/notes/alerts/${id}`,
        method: "PUT",
        body: model,
      }),
    }),
    deleteAlert: builder.mutation({
      query: (id) => ({
        url: `api/v1/foundation-service/notes/alerts/${id}`,
        method: "DELETE",
      })
    }),
    countAlertNotifications: builder.mutation({
      query: (model) => ({
        url: `api/v1/foundation-service/notes/alert-notifications/count`,
        method: "POST",
        body: model
      })
    }),
    resendAlertNotifications: builder.mutation({
      query: (model) => ({
        url: `api/v1/foundation-service/notes/alert-notifications/resend`,
        method: "POST",
        body: model
      })
    })
  }),
  overrideExisting: false,
});

export const {
  useGetNoteListMutation,
  useGetNoteCurrentListQuery,
  useInsertNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
  useTogglePinNoteMutation,
  useUploadNoteDocumentsMutation,
  useGetNoteDocumentsMutation,
  useDeleteNoteDocumentMutation,
  useGetNotesByUserQuery,
  useGetNoteAlertsQuery,
  useLazyGetNoteAlertsQuery,
  useUpdateAlertMutation,
  useDeleteAlertMutation,
  useCountAlertNotificationsMutation,
  useResendAlertNotificationsMutation
} = notesApi;
